import { FC, PropsWithChildren } from "react";
import { BaseProps } from "../../BaseProps";
import { getHtmlPropsFromBaseProps } from "../../utilities/getHtmlPropsFromBaseProps";
import legacyStyles from "./legacy/styles.module.scss";
import tokenStyles from "./styles.module.css";
import { createComponentStyleHook } from "../../tokens";

/**
 * The `Shadow` component properties.
 */

export interface ShadowProps extends BaseProps {}

const useStyles = createComponentStyleHook({
  legacyStyles,
  tokenStyles,
  componentTokens: "shadow",
});

/**
 * A simple container panel.
 */
export const Shadow: FC<PropsWithChildren<ShadowProps>> = (props) => {
  const { children } = props;
  const { mode, styles, StyleModeBoundary } = useStyles(props);

  const baseHtmlProps = getHtmlPropsFromBaseProps(props, {
    className: [styles.Shadow, "shadow"],
    testIdPrefix: "shadow",
  });

  return (
    <StyleModeBoundary mode={mode}>
      <div {...baseHtmlProps}>
        {children}
      </div>
    </StyleModeBoundary>
  );
};
